import { ContextMenu, SVG } from "shared";
import { SVG_ENUM } from "enums";
import moment from "moment";
import { downloadFile } from "utils";

const items = ({ setShowDelete }: { setShowDelete?: any }) => {
  return (document: any) => {
    const actions = [];
    if (document?.file?.url) {
      actions.push({
        name: "pobierz",
        action: () =>
          downloadFile({
            url: document.file.url,
            name: document.file.name,
          }),
        svg: SVG_ENUM.FILE,
      });
    }
    actions.push({
      name: "Usuń",
      action: () => setShowDelete && setShowDelete(document.uuid),
      svg: SVG_ENUM.TRASH,
    });

    return actions;
  };
};

const documentTypeMap: Record<string, string> = {
  testament: "Testament",
  notarial_documents: "Dokumenty notarialne",
  deed_of_ownership: "Akt własności",
  note: "Notatki prywatne",
};

export const mobileColumns = ({
  setShowDelete,
  canDelete = true,
}: {
  downloadFile?: any;
  setShowDelete?: any;
  canDelete?: boolean;
}) => [
  {
    render: (value: any) => {
      const label = value.name || "Brak";
      return (
        <div>
          <p>{label}</p>
        </div>
      );
    },
  },
  {
    width: 20,
    render: (item: any) =>
      canDelete ? (
        <ContextMenu
          data={item}
          items={items({
            setShowDelete,
          })(item)}
        >
          <SVG type={SVG_ENUM.DOTS} />
        </ContextMenu>
      ) : (
        <div
          className="context-menu__download"
          onClick={() =>
            downloadFile({ url: item.file.url, name: item.file.name })
          }
        >
          <SVG className="context-menu__icon" type={SVG_ENUM.FILE} />
        </div>
      ),
  },
];

export const desktopColumns = ({
  setShowDelete,
  canDelete = true,
}: {
  setShowDelete?: any;
  canDelete?: boolean;
}) => {
  const columns = [
    {
      title: "Nazwa",
      width: "20%",
      render: (value: any) => value.name || "Brak",
    },
    {
      width: "20%",
      title: "Typ",
      key: "type",
      dataIndex: "type",
      render: (type: string) => documentTypeMap[type] || "none",
    },
    {
      width: "25%",
      title: "Data dodania",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (date: string) => moment(date).format("DD.MM.YYYY"),
    },
    {
      width: "25%",
      title: "Opis",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Plik",
      width: 40,
      render: (item: any) => {
        return item?.file ? (
          <span
            className="clients-table__download"
            onClick={() =>
              downloadFile({ name: item.file.name, url: item.file.url })
            }
          >
            <SVG type={SVG_ENUM.FILE} />
          </span>
        ) : (
          "Brak"
        );
      },
    },
    {
      width: 20,
      render: (item: any) =>
        canDelete ? (
          <ContextMenu
            data={item}
            items={items({
              setShowDelete,
            })(item)}
          >
            <SVG type={SVG_ENUM.DOTS} />
          </ContextMenu>
        ) : (
          <div
            className="context-menu__download"
            onClick={() =>
              downloadFile({ url: item.file.url, name: item.file.name })
            }
          >
            <SVG className="context-menu__icon" type={SVG_ENUM.FILE} />
          </div>
        ),
    },
  ];

  return columns;
};
